import { useContext } from "react";
import { AppContext } from "../App";
import ContactUsLanding from "../views/ContactUsLanding";

export default function ContactUs() {
  const appContext = useContext(AppContext);

  if (!appContext.navSubItem && !appContext.navExtraItem && !appContext.navMoreItem) {
    return <ContactUsLanding />;
  }

  return null;
}

